/**
 * OCR新流程，扫描识别相关埋点
 * wiki: http://wiki.hellobike.com/pages/viewpage.action?pageId=377980633
 * */

/** 臻有钱_身份认证_新流程页面 曝光 */
export const TE_OCR_ENTER_NEW = 'finance_loan_ocr_identify_new';
/** 臻有钱_身份认证_删除确认弹窗 曝光 */
export const TE_OCR_DELETE_POPUP = 'finance_loan_ocr_identify_deletePopup';
/** 臻有钱_身份认证_切换模式弹窗 曝光 */
export const TE_OCR_EXCHANGE_POPUP = 'finance_loan_ocr_identify_exchangePopup';

/** 臻有钱_身份认证_协议 点击 */
export const TC_OCR_AGGREMENT = 'finance_loan_ocr_identify_aggrement';
/** 臻有钱_身份认证_拍摄 点击 */
export const TC_OCR_CAMERA = 'finance_loan_ocr_identify_camera';
/** 臻有钱_身份认证_相册上传 点击 */
export const TC_OCR_ALBUM = 'finance_loan_ocr_identify_album';

/** 臻有钱_身份认证_下一步按钮 曝光&点击 */
export const TQ_OCR_SUBMIT = 'finance_loan_ocr_identify_submit';

/** OCR统一方法 自定义埋点 流程开始 */
export const TCE_OCR_START = 'finance_others_ocr_start';
/** OCR统一方法 自定义埋点 客户端ocr bridge调用开始 */
export const TCE_OCR_CLIENT_BRIDGE_REQUEST = 'finance_others_ocr_client_bridge_request';
/** OCR统一方法 自定义埋点 客户端ocr bridge调用响应 */
export const TCE_OCR_CLIENT_BRIDGE_RESPONSE = 'finance_others_ocr_client_bridge_response';
/** OCR统一方法 自定义埋点 拍摄或相册 bridge调用成功 */
export const TCE_OCR_BRIDGE_SUCCESS = 'finance_others_ocr_bridge_success';
/** OCR统一方法 自定义埋点 拍摄或相册 bridge调用失败 */
export const TCE_OCR_BRIDGE_ERROR = 'finance_others_ocr_bridge_error';
/** OCR统一方法 自定义埋点 识别结果 */
export const TCE_OCR_RESULT = 'finance_others_ocr_result';
